import type { ReactNode } from 'react';
import { useState } from 'react';
import { Provider as ReduxProvider } from 'react-redux';

import { configureStore, subscribeDealerIdToSession } from '@makemydeal/dr-shared-store';
import type { HostEnvironment } from '@makemydeal/dr-shared-ui-utils';

import { getInitialMiddleware } from '../../shells/main/store/initialMiddleware';
import { getRemainingMiddleware } from '../../shells/main/store/remainingMiddleware';
import { createInitialReducers } from '../../shells/main/reducers/initialReducers';

export interface NewDealModuleProps {
    environment: HostEnvironment;
    children: ReactNode;
}

const state = {};
const allMiddleware = getInitialMiddleware().concat(getRemainingMiddleware());

export function StoreProvider({ environment, children }: NewDealModuleProps) {
    const [store] = useState(() => {
        // Store being created inside the component due to the dependency on environment
        // but we need to make sure configureStore is not called more than once because otherwise it will remove remaining reducers.
        const configuredStore = configureStore(state, allMiddleware, createInitialReducers(environment));
        subscribeDealerIdToSession(configuredStore);
        return configuredStore;
    });

    return <ReduxProvider store={store}>{children}</ReduxProvider>;
}
